module.exports = __webpack_public_path__ + "img/connector-types-desktop.dd58d723.webp";